module.exports = __webpack_public_path__ + "img/courses2.4f0e20d7.jpg";